/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Admin BFF API
 * Authentication and admin gateway for the AvilaRoffe platform.
 * OpenAPI spec version: 1.0
 */
import type {
  DeleteChatSessionsId401,
  DeleteChatSessionsId404,
  DeleteChatSessionsId502,
  DeleteChatSessionsIdMessages401,
  DeleteChatSessionsIdMessages404,
  DeleteChatSessionsIdMessages502,
  GetChatSessions200,
  GetChatSessions401,
  GetChatSessions502,
  GetChatSessionsId200,
  GetChatSessionsId401,
  GetChatSessionsId404,
  GetChatSessionsId502,
  GetChatSessionsIdMessages200,
  GetChatSessionsIdMessages401,
  GetChatSessionsIdMessages404,
  GetChatSessionsIdMessages502,
  GetChatSessionsIdMessagesParams,
  GetChatSessionsParams,
  PostChatSessions201,
  PostChatSessions400,
  PostChatSessions401,
  PostChatSessions502,
  PostChatSessionsBody,
  PostChatSessionsIdClose200,
  PostChatSessionsIdClose401,
  PostChatSessionsIdClose404,
  PostChatSessionsIdClose502,
  PostChatSessionsIdMessages201,
  PostChatSessionsIdMessages400,
  PostChatSessionsIdMessages401,
  PostChatSessionsIdMessages404,
  PostChatSessionsIdMessages502,
  PostChatSessionsIdMessagesBody
} from '../adminBFFAPI.schemas';

import { adminBffFetch } from '../../mutator';

/**
 * Proxied to chat-manager. Returns paginated list of sessions.
 * @summary List chat sessions
 */
export type getChatSessionsResponse200 = {
  data: GetChatSessions200
  status: 200
}

export type getChatSessionsResponse401 = {
  data: GetChatSessions401
  status: 401
}

export type getChatSessionsResponse502 = {
  data: GetChatSessions502
  status: 502
}
    
export type getChatSessionsResponseSuccess = (getChatSessionsResponse200) & {
  headers: Headers;
};
export type getChatSessionsResponseError = (getChatSessionsResponse401 | getChatSessionsResponse502) & {
  headers: Headers;
};

export type getChatSessionsResponse = (getChatSessionsResponseSuccess | getChatSessionsResponseError)

export const getGetChatSessionsUrl = (params?: GetChatSessionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/chat/sessions?${stringifiedParams}` : `/chat/sessions`
}

export const getChatSessions = async (params?: GetChatSessionsParams, options?: RequestInit): Promise<getChatSessionsResponse> => {
  
  return adminBffFetch<getChatSessionsResponse>(getGetChatSessionsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * Proxied to chat-manager. Creates a new session for the given agent.
 * @summary Create a chat session
 */
export type postChatSessionsResponse201 = {
  data: PostChatSessions201
  status: 201
}

export type postChatSessionsResponse400 = {
  data: PostChatSessions400
  status: 400
}

export type postChatSessionsResponse401 = {
  data: PostChatSessions401
  status: 401
}

export type postChatSessionsResponse502 = {
  data: PostChatSessions502
  status: 502
}
    
export type postChatSessionsResponseSuccess = (postChatSessionsResponse201) & {
  headers: Headers;
};
export type postChatSessionsResponseError = (postChatSessionsResponse400 | postChatSessionsResponse401 | postChatSessionsResponse502) & {
  headers: Headers;
};

export type postChatSessionsResponse = (postChatSessionsResponseSuccess | postChatSessionsResponseError)

export const getPostChatSessionsUrl = () => {


  

  return `/chat/sessions`
}

export const postChatSessions = async (postChatSessionsBody: PostChatSessionsBody, options?: RequestInit): Promise<postChatSessionsResponse> => {
  
  return adminBffFetch<postChatSessionsResponse>(getPostChatSessionsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postChatSessionsBody,)
  }
);}


/**
 * Proxied to chat-manager.
 * @summary Get a chat session by ID
 */
export type getChatSessionsIdResponse200 = {
  data: GetChatSessionsId200
  status: 200
}

export type getChatSessionsIdResponse401 = {
  data: GetChatSessionsId401
  status: 401
}

export type getChatSessionsIdResponse404 = {
  data: GetChatSessionsId404
  status: 404
}

export type getChatSessionsIdResponse502 = {
  data: GetChatSessionsId502
  status: 502
}
    
export type getChatSessionsIdResponseSuccess = (getChatSessionsIdResponse200) & {
  headers: Headers;
};
export type getChatSessionsIdResponseError = (getChatSessionsIdResponse401 | getChatSessionsIdResponse404 | getChatSessionsIdResponse502) & {
  headers: Headers;
};

export type getChatSessionsIdResponse = (getChatSessionsIdResponseSuccess | getChatSessionsIdResponseError)

export const getGetChatSessionsIdUrl = (id: string,) => {


  

  return `/chat/sessions/${id}`
}

export const getChatSessionsId = async (id: string, options?: RequestInit): Promise<getChatSessionsIdResponse> => {
  
  return adminBffFetch<getChatSessionsIdResponse>(getGetChatSessionsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * Proxied to chat-manager.
 * @summary Delete a chat session
 */
export type deleteChatSessionsIdResponse204 = {
  data: void
  status: 204
}

export type deleteChatSessionsIdResponse401 = {
  data: DeleteChatSessionsId401
  status: 401
}

export type deleteChatSessionsIdResponse404 = {
  data: DeleteChatSessionsId404
  status: 404
}

export type deleteChatSessionsIdResponse502 = {
  data: DeleteChatSessionsId502
  status: 502
}
    
export type deleteChatSessionsIdResponseSuccess = (deleteChatSessionsIdResponse204) & {
  headers: Headers;
};
export type deleteChatSessionsIdResponseError = (deleteChatSessionsIdResponse401 | deleteChatSessionsIdResponse404 | deleteChatSessionsIdResponse502) & {
  headers: Headers;
};

export type deleteChatSessionsIdResponse = (deleteChatSessionsIdResponseSuccess | deleteChatSessionsIdResponseError)

export const getDeleteChatSessionsIdUrl = (id: string,) => {


  

  return `/chat/sessions/${id}`
}

export const deleteChatSessionsId = async (id: string, options?: RequestInit): Promise<deleteChatSessionsIdResponse> => {
  
  return adminBffFetch<deleteChatSessionsIdResponse>(getDeleteChatSessionsIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


/**
 * Proxied to chat-manager. Marks the session as closed; no further messages accepted.
 * @summary Close a chat session
 */
export type postChatSessionsIdCloseResponse200 = {
  data: PostChatSessionsIdClose200
  status: 200
}

export type postChatSessionsIdCloseResponse401 = {
  data: PostChatSessionsIdClose401
  status: 401
}

export type postChatSessionsIdCloseResponse404 = {
  data: PostChatSessionsIdClose404
  status: 404
}

export type postChatSessionsIdCloseResponse502 = {
  data: PostChatSessionsIdClose502
  status: 502
}
    
export type postChatSessionsIdCloseResponseSuccess = (postChatSessionsIdCloseResponse200) & {
  headers: Headers;
};
export type postChatSessionsIdCloseResponseError = (postChatSessionsIdCloseResponse401 | postChatSessionsIdCloseResponse404 | postChatSessionsIdCloseResponse502) & {
  headers: Headers;
};

export type postChatSessionsIdCloseResponse = (postChatSessionsIdCloseResponseSuccess | postChatSessionsIdCloseResponseError)

export const getPostChatSessionsIdCloseUrl = (id: string,) => {


  

  return `/chat/sessions/${id}/close`
}

export const postChatSessionsIdClose = async (id: string, options?: RequestInit): Promise<postChatSessionsIdCloseResponse> => {
  
  return adminBffFetch<postChatSessionsIdCloseResponse>(getPostChatSessionsIdCloseUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}


/**
 * Proxied to chat-manager.
 * @summary Get messages in a chat session
 */
export type getChatSessionsIdMessagesResponse200 = {
  data: GetChatSessionsIdMessages200
  status: 200
}

export type getChatSessionsIdMessagesResponse401 = {
  data: GetChatSessionsIdMessages401
  status: 401
}

export type getChatSessionsIdMessagesResponse404 = {
  data: GetChatSessionsIdMessages404
  status: 404
}

export type getChatSessionsIdMessagesResponse502 = {
  data: GetChatSessionsIdMessages502
  status: 502
}
    
export type getChatSessionsIdMessagesResponseSuccess = (getChatSessionsIdMessagesResponse200) & {
  headers: Headers;
};
export type getChatSessionsIdMessagesResponseError = (getChatSessionsIdMessagesResponse401 | getChatSessionsIdMessagesResponse404 | getChatSessionsIdMessagesResponse502) & {
  headers: Headers;
};

export type getChatSessionsIdMessagesResponse = (getChatSessionsIdMessagesResponseSuccess | getChatSessionsIdMessagesResponseError)

export const getGetChatSessionsIdMessagesUrl = (id: string,
    params?: GetChatSessionsIdMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/chat/sessions/${id}/messages?${stringifiedParams}` : `/chat/sessions/${id}/messages`
}

export const getChatSessionsIdMessages = async (id: string,
    params?: GetChatSessionsIdMessagesParams, options?: RequestInit): Promise<getChatSessionsIdMessagesResponse> => {
  
  return adminBffFetch<getChatSessionsIdMessagesResponse>(getGetChatSessionsIdMessagesUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * Proxied to chat-manager. Appends a user message and triggers agent response.
 * @summary Send a message in a chat session
 */
export type postChatSessionsIdMessagesResponse201 = {
  data: PostChatSessionsIdMessages201
  status: 201
}

export type postChatSessionsIdMessagesResponse400 = {
  data: PostChatSessionsIdMessages400
  status: 400
}

export type postChatSessionsIdMessagesResponse401 = {
  data: PostChatSessionsIdMessages401
  status: 401
}

export type postChatSessionsIdMessagesResponse404 = {
  data: PostChatSessionsIdMessages404
  status: 404
}

export type postChatSessionsIdMessagesResponse502 = {
  data: PostChatSessionsIdMessages502
  status: 502
}
    
export type postChatSessionsIdMessagesResponseSuccess = (postChatSessionsIdMessagesResponse201) & {
  headers: Headers;
};
export type postChatSessionsIdMessagesResponseError = (postChatSessionsIdMessagesResponse400 | postChatSessionsIdMessagesResponse401 | postChatSessionsIdMessagesResponse404 | postChatSessionsIdMessagesResponse502) & {
  headers: Headers;
};

export type postChatSessionsIdMessagesResponse = (postChatSessionsIdMessagesResponseSuccess | postChatSessionsIdMessagesResponseError)

export const getPostChatSessionsIdMessagesUrl = (id: string,) => {


  

  return `/chat/sessions/${id}/messages`
}

export const postChatSessionsIdMessages = async (id: string,
    postChatSessionsIdMessagesBody: PostChatSessionsIdMessagesBody, options?: RequestInit): Promise<postChatSessionsIdMessagesResponse> => {
  
  return adminBffFetch<postChatSessionsIdMessagesResponse>(getPostChatSessionsIdMessagesUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postChatSessionsIdMessagesBody,)
  }
);}


/**
 * Proxied to chat-manager.
 * @summary Delete all messages in a chat session
 */
export type deleteChatSessionsIdMessagesResponse204 = {
  data: void
  status: 204
}

export type deleteChatSessionsIdMessagesResponse401 = {
  data: DeleteChatSessionsIdMessages401
  status: 401
}

export type deleteChatSessionsIdMessagesResponse404 = {
  data: DeleteChatSessionsIdMessages404
  status: 404
}

export type deleteChatSessionsIdMessagesResponse502 = {
  data: DeleteChatSessionsIdMessages502
  status: 502
}
    
export type deleteChatSessionsIdMessagesResponseSuccess = (deleteChatSessionsIdMessagesResponse204) & {
  headers: Headers;
};
export type deleteChatSessionsIdMessagesResponseError = (deleteChatSessionsIdMessagesResponse401 | deleteChatSessionsIdMessagesResponse404 | deleteChatSessionsIdMessagesResponse502) & {
  headers: Headers;
};

export type deleteChatSessionsIdMessagesResponse = (deleteChatSessionsIdMessagesResponseSuccess | deleteChatSessionsIdMessagesResponseError)

export const getDeleteChatSessionsIdMessagesUrl = (id: string,) => {


  

  return `/chat/sessions/${id}/messages`
}

export const deleteChatSessionsIdMessages = async (id: string, options?: RequestInit): Promise<deleteChatSessionsIdMessagesResponse> => {
  
  return adminBffFetch<deleteChatSessionsIdMessagesResponse>(getDeleteChatSessionsIdMessagesUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


